export const getApiErrorMessage = (body) => {
    const message = body?.error;
    return typeof message === "string" && message.trim()
        ? message.trim()
        : null;
};

export const SUPPORT_SUFFIX = "Contact NLA Support.";

export const withSupportContact = (message) => {
    const trimmed = typeof message === "string" ? message.trim() : "";
    if (!trimmed) return SUPPORT_SUFFIX;
    return `${trimmed.replace(/[.!]+$/, "")}. ${SUPPORT_SUFFIX}`;
};

export const readApiErrorMessage = async (response) => {
    try {
        return getApiErrorMessage(await response.json());
    } catch (error) {
        return null;
    }
};
